<template>
  <div class="mainList">
    <el-dialog :visible.sync="fundDetailDialogVisible" title="资金明细" @close="close" width="70%">
      <el-select v-model="symbol" placeholder="请选择合约" clearable>
        <el-option v-for="item in symbolList" :key="item.id" :label="item.symbol" :value="item.symbol">
        </el-option>
      </el-select>
      <el-date-picker v-model="value1" type="datetimerange" align="right" format="yyyy-MM-dd HH:mm:ss"
        value-format="timestamp" unlink-panels range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
        :picker-options="pickerOptions" @change="changeTime">
      </el-date-picker>

      <el-button size="mini" @click="handleSearch" type="primary">搜索</el-button>
      <el-table :data="fundDetailList" style="width: 100%" class="myTable" max-height="400px">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="symbol" label="合约名" />
        <el-table-column prop="accountId" label="合约账户ID" />
        <el-table-column prop="userId" label="用户ID" />
        <el-table-column prop="positionValue" label="仓位价值" />

        <el-table-column label="仓位类型">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.positionSide === 0">单向持仓，正数为多，负数为空</span>
            <span class="green" v-if="scope.row.positionSide === 1">多</span>
            <span class="green" v-if="scope.row.positionSide === 2">空</span>
          </template>
        </el-table-column>
        <el-table-column prop="fundRateRecordId" label="资金费用记录ID" />
        <el-table-column prop="cast" label="费用" />

        <el-table-column label="费率">
          <template slot-scope="scope">
            <span>{{
              formatSignedFundingRate(scope.row)
              }}%</span>
          </template>
        </el-table-column>

        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updatedTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="paginations.size" :page="paginations.page" :total="fundDetailTotal"
        @pageChanged="handlePageChangedDialog">
      </pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import BigNumber from 'bignumber.js'
import { mapState, mapActions, mapMutations } from 'vuex'

import moment from 'moment'

export default {
  props: [
    'fundDetailDialogVisible',
    'fundDetailRow',
    'closefundDetail',
    'topChannelUserId',
    'startTime',
    'endTime',
    'fundDetailTimeRange',
  ],
  data() {
    return {
      paginations: {
        page: 1,
        size: 10,
      },
      symbol: '',
      value1: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  components: { Pagination },
  watch: {
    fundDetailDialogVisible: {
      handler(val, oldVal) {
        if (val) {
          this.symbol = this.fundDetailRow.symbol
          this.value1 = this.getInitialTimeRange()
          this.getList()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState('transactionStatistics', [
      'fundDetailList',
      'fundDetailTotal',
      'symbolList',
    ]),
  },

  methods: {
    ...mapActions('transactionStatistics', ['fetchFundDetail']),

    normalizeHourRange(range) {
      if (!range || range.length !== 2) {
        return []
      }

      const start = moment(range[0])
      const end = moment(range[1])

      if (!start.isValid() || !end.isValid()) {
        return []
      }

      return [
        start.startOf('hour').valueOf(),
        end.endOf('hour').millisecond(0).valueOf(),
      ]
    },

    getInitialTimeRange() {
      const detailRange = this.normalizeHourRange(this.fundDetailTimeRange)

      if (detailRange.length === 2) {
        return detailRange
      }

      return this.normalizeHourRange([this.startTime, this.endTime])
    },

    changeTime(value) {
      this.value1 = this.normalizeHourRange(value)
    },

    formatSignedFundingRate(row) {
      const fundingRate = Math.abs(Number(row.fundingRate || 0))
      const cast = Number(row.cast || 0)
      const positionSide = Number(row.positionSide)

      let castSign = 0
      if (cast > 0) castSign = 1
      if (cast < 0) castSign = -1

      // 多仓：费率符号与 cast 相反；空仓：费率符号与 cast 一致
      let sign = castSign
      if (positionSide === 1) {
        sign = -castSign
      } else if (positionSide === 2) {
        sign = castSign
      }

      const percent = BigNumber(fundingRate).times(100).toNumber()
      const fixed = this.$options.filters.fixD(Math.abs(percent), 6)

      // 仅负值显示 "-"，正值不显示 "+"
      if (sign < 0 && Number(fixed) !== 0) {
        return `-${fixed}`
      }
      return `${fixed}`
    },

    handlePageChangedDialog(pagination) {
      this.paginations = pagination
      this.getList()
    },

    getList() {
      const timeRange = this.normalizeHourRange(this.value1)
      this.fetchFundDetail({
        ...this.paginations,
        symbol: this.symbol,
        startTime: timeRange.length === 2 ? timeRange[0] : '',
        endTime: timeRange.length === 2 ? timeRange[1] : '',
        topUserId: this.topChannelUserId,
      })
    },
    handleSearch() {
      this.getList()
    },

    close() {
      this.$emit('closefundDetail')
    },
  },
}
</script>

<style lang="less" scoped>
.el-table__header {
  width: 100% !important;

  th.el-table__cell.is-leaf {
    background: #ccc;
  }
}

.el-table__body {
  width: 100% !important;
}

.userBalance {
  color: #409eff;
  cursor: pointer;
}

.userIdInput {
  width: 300px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

/deep/.el-date-editor {
  margin: 0 20px;
}
</style>
